import { render, staticRenderFns } from "./LeaderGameAssign.vue?vue&type=template&id=22d8e0a2&scoped=true"
import script from "./LeaderGameAssign.vue?vue&type=script&lang=js"
export * from "./LeaderGameAssign.vue?vue&type=script&lang=js"
import style0 from "./LeaderGameAssign.vue?vue&type=style&index=0&id=22d8e0a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d8e0a2",
  null
  
)

export default component.exports